export class CompanyUpdateRefusalReasonDto {
  email?: boolean;
  nameKr?: boolean;
  nameEng?: boolean;
  ceoKr?: boolean;
  ceoEng?: boolean;
  address?: boolean;
  website?: boolean;
  fax?: boolean;
  phone?: boolean;
  population?: boolean;
  businessNo?: boolean;
}
